export const API_BASE_URL = (import.meta as { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL ?? 'http://localhost:5000/api';

export function buildHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('rithmo_token') : null;
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export async function requestTtsAudio(input: {
  text: string;
  voice?: string;
  format?: 'mp3' | 'wav';
  speed?: number;
  signal?: AbortSignal;
  /** Override TTS provider for this request. */
  provider?: 'openai' | 'deepgram' | 'elevenlabs';
}): Promise<{
  blob: Blob;
  contentType: string;
}> {
  const { signal, provider, ...body } = input;
  const response = await fetch(`${API_BASE_URL}/tts`, {
    method: 'POST',
    headers: buildHeaders(),
    signal,
    body: JSON.stringify(provider ? { ...body, provider } : body),
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(errorBody.message ?? `HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const contentType = response.headers.get('Content-Type') ?? 'audio/mpeg';
  return { blob, contentType };
}

export const ttsApi = {
  speak: requestTtsAudio,
};
